/* ==========================================================================
   assets/armonia-outfit.js – drawer «Prendi il look»
   - apre/chiude il <dialog> dedicato (non il drawer del carrello)
   - scelta taglie, progresso premio, sblocco con animazione (una volta per apertura)
   - aggiunge TUTTI i capi con una sola chiamata /cart/add.js e porta alla pagina carrello
   ========================================================================== */
(function () {
  'use strict';

  var LOCK = 'armonia-outfit-lock';

  function track(name, params) {
    /* ASSUNZIONE: armonia-global.js espone window.armoniaTrack(name, params). Se non c'è, push su dataLayer. */
    try {
      if (typeof window.armoniaTrack === 'function') { window.armoniaTrack(name, params || {}); return; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) { /* il tracking non deve mai rompere il flusso */ }
  }

  function formatMoney(cents, format) {
    var n = Math.round(cents) / 100;
    var s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (/,00$/.test(s) && /no_decimals|amount_no_decimals/.test(format || '')) s = s.replace(/,00$/, '');
    var m = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount_with_comma_separator';
    var val;
    switch (kind) {
      case 'amount_no_decimals': val = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount': val = n.toFixed(2); break;
      case 'amount_no_decimals_with_comma_separator': val = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_with_comma_separator':
      default: val = s;
    }
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function fill(str, map) {
    var out = str || '';
    Object.keys(map).forEach(function (k) { out = out.split(k).join(map[k]); });
    return out;
  }

  function initLook(root) {
    if (!root || root.__armoniaOutfit) return;
    var sheet = root.querySelector('[data-armonia-outfit-sheet]');
    if (!sheet) return;
    root.__armoniaOutfit = true;

    var d = sheet.dataset;
    var reward = d.reward || 'none';
    var percent = parseInt(d.percent, 10) || 0;
    var giftVariant = d.giftVariant;
    var look = d.look;
    var fmt = d.moneyFormat;
    var rows = [].slice.call(sheet.querySelectorAll('[data-outfit-row]'));
    var addBtn = sheet.querySelector('[data-armonia-outfit-add]');
    var ctaLabel = sheet.querySelector('[data-cta-label]');
    var ctaDefault = ctaLabel ? ctaLabel.textContent : '';
    var totalEl = sheet.querySelector('[data-total]');
    var totalOld = sheet.querySelector('[data-total-old]');
    var locked = sheet.querySelector('[data-reward-locked]');
    var unlocked = sheet.querySelector('[data-reward-unlocked]');
    var bar = sheet.querySelector('[data-progress-bar]');
    var progressLabel = sheet.querySelector('[data-progress-label]');
    var missingInline = sheet.querySelector('[data-missing-inline]');
    var missing = sheet.querySelector('[data-missing]');
    var errorEl = sheet.querySelector('[data-error]');
    var live = sheet.querySelector('[data-live]');
    var opener = null;
    var wasUnlocked = false;
    var busy = false;

    function chosen(row) { return row.querySelector('.armonia-outfit-size[aria-pressed="true"][data-variant-id]'); }

    function update(animate) {
      var done = 0, total = 0, names = [];
      rows.forEach(function (row) {
        var sel = chosen(row);
        var base = parseInt(row.dataset.basePrice, 10) || 0;
        if (sel) { done++; total += parseInt(sel.dataset.price, 10) || base; }
        else { total += base; names.push(row.dataset.name); }
      });
      var all = rows.length > 0 && done === rows.length;
      var left = rows.length - done;

      var discounted = total;
      if (all && reward === 'discount' && percent) discounted = Math.round(total * (100 - percent) / 100);
      if (totalEl) totalEl.textContent = formatMoney(discounted, fmt);
      if (totalOld) {
        if (discounted !== total) { totalOld.textContent = formatMoney(total, fmt); totalOld.hidden = false; }
        else { totalOld.hidden = true; totalOld.textContent = ''; }
      }

      if (addBtn) addBtn.disabled = !all || busy;

      if (missing) {
        missing.textContent = all ? '' : (left === 1
          ? fill(d.tMissingOne, { '__NAME__': names[0] })
          : fill(d.tMissingMany, { '__N__': left }));
        missing.classList.remove('is-ok');
      }

      if (reward !== 'none') {
        if (bar) bar.style.width = (rows.length ? (done / rows.length) * 100 : 0) + '%';
        if (progressLabel) progressLabel.textContent = fill(d.tProgress, { '__DONE__': done, '__TOTAL__': rows.length });
        if (missingInline) {
          missingInline.textContent = all ? '' : (left === 1
            ? fill(d.tMissingInlineOne, { '__NAME__': names[0] })
            : fill(d.tMissingInlineMany, { '__N__': left }));
        }
        if (locked) locked.hidden = all;
        if (unlocked) {
          unlocked.hidden = !all;
          if (all && !wasUnlocked && animate) {
            unlocked.classList.remove('is-animating');
            void unlocked.offsetWidth;
            unlocked.classList.add('is-animating');
            if (live) live.textContent = d.tLiveUnlocked || '';
            track('outfit_unlock', { reward: reward, look: look });
          }
          if (!all) unlocked.classList.remove('is-animating');
        }
      } else if (missing) {
        /* niente premio: il messaggio "manca la taglia" resta solo in missing */
      }
      wasUnlocked = all;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    /* --- Apri / chiudi --- */
    function open(btn) {
      opener = btn || null;
      usedKeyboard = false;
      showError('');
      if (typeof sheet.showModal === 'function') { if (!sheet.open) sheet.showModal(); }
      else sheet.setAttribute('open', '');
      document.documentElement.classList.add(LOCK);
      wasUnlocked = rows.length > 0 && rows.every(function (r) { return chosen(r); });
      update(false);
    }

    function close() {
      if (!sheet.open) return;
      var finish = function () {
        sheet.classList.remove('is-closing');
        if (typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
      };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { finish(); return; }
      sheet.classList.add('is-closing');
      setTimeout(finish, 190);
    }

    /* Chiuso col mouse/dito: nessun anello di focus sul bottone (Safari lo mostrava dopo la chiusura).
       Chiuso da tastiera: il focus torna al bottone, visibile, per chi naviga con Tab. */
    var usedKeyboard = false;
    sheet.addEventListener('keydown', function () { usedKeyboard = true; });
    sheet.addEventListener('pointerdown', function () { usedKeyboard = false; });

    sheet.addEventListener('close', function () {
      document.documentElement.classList.remove(LOCK);
      sheet.classList.remove('is-closing');
      var btn = opener;
      if (!btn || !document.contains(btn)) return;
      if (usedKeyboard) {
        try { btn.focus(); } catch (e) {}
      } else {
        /* il browser ripristina il focus da solo: lo togliamo subito dopo */
        var drop = function () { if (document.activeElement === btn) btn.blur(); };
        drop();
        window.requestAnimationFrame(drop);
        setTimeout(drop, 50);
      }
    });
    /* Esc: chiusura con la stessa animazione */
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    /* click sul backdrop */
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) close();
    });

    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-armonia-outfit-open]');
      if (o && root.contains(o)) { e.preventDefault(); open(o); return; }
    });
    var closeBtn = sheet.querySelector('[data-armonia-outfit-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* --- Scelta taglia --- */
    sheet.addEventListener('click', function (e) {
      var btn = e.target.closest('.armonia-outfit-size');
      if (!btn || !sheet.contains(btn)) return;
      if (btn.classList.contains('is-off') || btn.getAttribute('aria-disabled') === 'true') return;
      var row = btn.closest('[data-outfit-row]');
      if (!row) return;
      row.querySelectorAll('.armonia-outfit-size').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      showError('');
      track('outfit_size_select', { look: look, product: row.dataset.name });
      update(true);
    });

    /* --- Aggiungi tutto e vai al carrello --- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (busy) return;
        var items = [];
        var ok = true;
        rows.forEach(function (row) {
          var sel = chosen(row);
          if (!sel) { ok = false; return; }
          items.push({ id: parseInt(sel.dataset.variantId, 10), quantity: 1, properties: { _look: look } });
        });
        if (!ok || !items.length) return;
        if (reward === 'gift' && giftVariant) {
          items.push({ id: parseInt(giftVariant, 10), quantity: 1, properties: { _look: look, _omaggio: 'true' } });
        }

        busy = true;
        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
        if (ctaLabel) ctaLabel.textContent = d.tAdding || ctaLabel.textContent;
        showError('');

        fetch(d.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (body) { return { ok: res.ok, status: res.status, body: body }; });
          })
          .then(function (r) {
            if (!r.ok) {
              var err = new Error('add_failed');
              err.status = r.status;
              err.stock = r.status === 422;
              throw err;
            }
            track('outfit_add', { look: look, items: items.length, reward: reward });
            window.location.href = d.cartUrl;
          })
          .catch(function (err) {
            busy = false;
            addBtn.removeAttribute('aria-busy');
            if (ctaLabel) ctaLabel.textContent = ctaDefault;
            showError(err && err.stock ? d.tErrorStock : d.tError);
            update(false);
          });
      });
    }

    update(false);
  }


  /* --- Sezione: look multipli + adattamento all'altezza dello schermo --- */
  function init(sec) {
    if (!sec || sec.__armoniaOutfitSec) return;
    sec.__armoniaOutfitSec = true;
    var looks = [].slice.call(sec.querySelectorAll('[data-armonia-outfit-look]'));
    looks.forEach(initLook);

    var ids = looks.map(function (l) { return l.dataset.lookIndex; });
    var tabs = [].slice.call(sec.querySelectorAll('[data-look-tab]'));
    var texts = [].slice.call(sec.querySelectorAll('[data-look-text]'));
    var liveEl = sec.querySelector('[data-look-live]');
    var current = 0;
    var flip = false;

    function show(n, user) {
      if (looks.length < 2) return;
      n = (n + looks.length) % looks.length;
      if (n === current && !user) return;
      current = n;
      flip = !flip;
      var id = ids[n];
      looks.forEach(function (l, i) {
        l.classList.remove('is-in-a', 'is-in-b');
        l.hidden = i !== n;
      });
      looks[n].classList.add(flip ? 'is-in-a' : 'is-in-b');
      tabs.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.lookTab === id ? 'true' : 'false'); });
      texts.forEach(function (p) { p.hidden = p.dataset.lookText !== id; });
      if (liveEl && liveEl.dataset.tLive) {
        liveEl.textContent = fill(liveEl.dataset.tLive, { '__N__': n + 1, '__T__': looks.length });
      }
      track('outfit_look_change', { look: id });
      queueFit();
    }

    sec.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-look-tab]');
      if (tab && sec.contains(tab)) { show(ids.indexOf(tab.dataset.lookTab), true); return; }
      if (e.target.closest('[data-look-prev]')) { show(current - 1, true); return; }
      if (e.target.closest('[data-look-next]')) { show(current + 1, true); }
    });

    /* Swipe orizzontale sulla foto (mobile) */
    var sx = 0, sy = 0, tracking = false;
    sec.addEventListener('touchstart', function (e) {
      var ph = e.target.closest ? e.target.closest('.armonia-outfit__photo') : null;
      if (!ph || looks.length < 2 || e.touches.length !== 1) { tracking = false; return; }
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1), true);
    }, { passive: true });

    /* --- Desktop: tutto il box in una schermata ---
       Il CSS limita l'altezza della foto allo spazio che resta sotto l'header sticky, ma ha bisogno
       dell'altezza reale di titolo + testo (--o-head-h). Qui la misuro (poche iterazioni, perché la
       larghezza del box cambia con l'altezza e il titolo può andare a capo diversamente). */
    var head = sec.querySelector('.armonia-outfit__head');
    var desktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    var fitTick = false;
    function fit() {
      fitTick = false;
      if (!head) return;
      if (!desktop || !desktop.matches) { sec.style.removeProperty('--o-head-h'); return; }
      var h = 96, best = 0, m, i;
      for (i = 0; i < 4; i++) {
        sec.style.setProperty('--o-head-h', h + 'px');
        m = head.getBoundingClientRect().height;
        if (m > best) best = m;
        if (Math.abs(m - h) < 1) break;
        h = m;
      }
      sec.style.setProperty('--o-head-h', Math.ceil(best) + 'px');
    }
    function queueFit() {
      if (fitTick) return;
      fitTick = true;
      window.requestAnimationFrame(fit);
    }
    window.addEventListener('resize', queueFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);
    fit();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-armonia-outfit]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove(LOCK);
  });
})();
